import React from 'react';
import Peter from '../../images/peter.jpeg';
import Guy from '../../images/guy.jpg';
import Matt from '../../images/matt.jpg';
import JoeT from '../../images/josepht.jpg';
import { Card, Container, Divider, Header, Image, Modal } from 'semantic-ui-react';

// import './style.css';

class Team extends React.Component {
  state = {
    width:0,
    height:0
  }

  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render(){
    return <div className="Staff">
    <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
        Management Team
      </Header>
      <p>
        OVC is led by four seasoned professionals with experience in bioscience and business.
      </p>

    </Container>
    <Divider/>

    { this.state.width < 768 ?
    <Card.Group itemsPerRow={1} centered>
      <Modal size='small' trigger={
        <Card color='blue'>
          <Image src={Matt} wrapped ui={false} />
          <Card.Content>
            <Card.Header>Dr. Matthew Daniels</Card.Header>
            <Card.Description>
              Chairman
            </Card.Description>
          </Card.Content>
        </Card>
      }>
      <Modal.Header>Dr. Matthew Daniels, Chairman</Modal.Header>
      <Modal.Content scrolling >
        <Modal.Description>
          <Header>
            BSc (Nottm), MA. MB, BChir, PhD (Cantab), MRCP FSCAI, Consultant Physician (Cardiology)
          </Header>
          <p className="Card__Text__Body">
          Senior Lecturer University of Manchester-division of cardiovascular medicine & division of cell matrix biology & regenerative medicine. Honorary Consultant Cardiologist, University of Manchester NHS Foundation Trust. 
          Lead for Clinical research at the Manchester Heart Centre.
        <br/>
          Formerly Academic Consultant Cardiologist and principal investigator; a cardio-vascular and bioimaging expert, 
          with clinical practice in structural and inherited heart disease (Oxford University Hospital). Led research program 
          (Oxford University BHF Centre of Research Excellence and Osaka University) investigating real-time visualization of 
          intracellular signaling in the context of inherited cardiomyopathy, diabetes, and stem-cell derivatives that 
          might be used in cardiac regeneration, by high-content advanced light microscopy. Fellow of the Society of Cardiac 
          Angiography and Interventions (Congenital council structural heart sub-committee). Member of the Royal College of Physicians, 
          the Association of Inherited Cardiac Conditions, the British Cardiac Society (Program Committee), 
          and the Genomics England Clinical Interpretation Panel (Cardiovascular sub-domain).
        </p>
          </Modal.Description>
      </Modal.Content>
    </Modal>

    <Modal size='small' trigger={
      <Card color='blue'>
        <Image src={JoeT} size='tiny' wrapped ui={false} />
        <Card.Content>
          <Card.Header>Dr. Joseph Wing-On Tam</Card.Header>
          <Card.Description>
            Vice Chairman
          </Card.Description>
        </Card.Content>
      </Card>
    }>
      <Modal.Header>Dr. Joseph Wing-On Tam, Vice Chairman</Modal.Header>
      <Modal.Content scrolling >
        <Modal.Description>
          <Header>
            PhD Chemistry (UC Davis), Postdoctoral (Northwestern)
          </Header>
          <p className="Card__Text__Body">
            Research pioneer with over 30 years of teaching and research experience in the biotechnology and diagnostics sector.
            Honorary Professor of the School of Biomedical Science and Retired Professor of Biochemistry at Li Ka Shing Faculty of Medicine, The
            University of Hong Kong. Founder, Retired CEO and Chairman, DiagCor Bioscience and Pangenia, Hong Kong.  Founder and President of the Hong Kong
            Biochemistry Association.  Visiting Professor at UCSF, Baylor Medical College, and Medical College of Georgia; Scientist of National Institute of Health.
          </p>
          </Modal.Description>
      </Modal.Content>
    </Modal>

    <Modal size='small' trigger={
      <Card color='blue'>
        <Image src={Peter} wrapped ui={false} />
        <Card.Content>
          <Card.Header>Peter Cheung</Card.Header>
          <Card.Description>
            CEO and Chief Investment Officer
          </Card.Description>
        </Card.Content>
      </Card>
    }>
      <Modal.Header>Peter Cheung, CEO and Chief Investment Officer</Modal.Header>
      <Modal.Content scrolling >
        <Modal.Description>
          <Header>
            MSc Major Programme Management (Oxford), MBA (USC), BSc Economics & Statistics (Hawaii).
            Chartered Financial Analyst with completion of investment management
            workshops at Princeton and Cambridge
          </Header>
          <p className="Card__Text__Body">
            Venture partner at Paladin Capital Group, a venture capital firm based in Washington, DC known for its expertise in cyber and bioscience investments.
            In 1983, founded Amervest Company, Inc. which served as external investment advisor to City of Los Angeles, L.A. Community Redevelopment Agency, Water Replenishment District,
            California Educational Facilities Financing Authority, L.A. County Mass Transit, Hong Kong Mass Transit Railway, and 20 other
            educational institutions.
            Formerly Treasurer and Chief Investment Officer at University of Southern California (USC), rose through the ranks from financial analyst.
            Worked as Executive Trainee at Citibank (Hong Kong) and promoted to Management Analyst at Citibank (Los Angeles).
            Active member of CFA Los Angeles chapter and alumni groups sponsored by USC and Oxford.
          </p>
        </Modal.Description>
      </Modal.Content>
    </Modal>

    <Modal size='small' trigger={
      <Card color='blue'>
        <Image src={Guy} wrapped ui={false} />
        <Card.Content>
          <Card.Header>Guy Marshall</Card.Header>
          <Card.Description>
            COO
          </Card.Description>
        </Card.Content>
      </Card>
    }>
    <Modal.Header>Guy Marshall, COO</Modal.Header>
    <Modal.Content scrolling >
      <Modal.Description>
        <Header>
          MSc Major Programme Management (Oxford), BSc Geography (UCL), PG Cert in Climate Change Management (University of London)
        </Header>
          <p className="Card__Text__Body">
            Senior sales person on the London equity sales desk of largest Russian bank Sberbank. Covered Central Asia for Kazakh investment bank Visor Capital
            and was head of the London office. At Citigroup, Director on the equity sales desk for Central and Eastern Europe, Middle
            East and Africa, covering major financial institutions in the UK, Germany, and Switzerland. At the beginning of career founded a tour company specialising in
            post-communist Central Europe, before joining Nomura and subsequently Schroders to launch the first IPOs in the region as the markets reopened.
          </p>
        </Modal.Description>
      </Modal.Content>
    </Modal>
    </Card.Group>
    :
    <Card.Group itemsPerRow={2} centered>
      <Modal size='large' trigger={
        <Card color='blue'>
        <Image src={Matt} wrapped ui={false} />
        <Card.Content>
          <Card.Header>Dr. Matthew Daniels</Card.Header>
          <Card.Description>
            Chairman
          </Card.Description>
        </Card.Content>
        </Card>
      }>
        <Modal.Header>Dr. Matthew Daniels, Chairman</Modal.Header>
        <Modal.Content scrolling >
          <Modal.Description>
            <Header>
              BSc (Nottm), MA. MB, BChir, PhD (Cantab), MRCP FSCAI, Consultant Physician (Cardiology)
            </Header>
            <p className="Card__Text__Body">
          Senior Lecturer University of Manchester-division of cardiovascular medicine & division of cell matrix biology & regenerative medicine. Honorary Consultant Cardiologist, University of Manchester NHS Foundation Trust. 
          Lead for Clinical research at the Manchester Heart Centre.
        <br/>
          Formerly Academic Consultant Cardiologist and principal investigator; a cardio-vascular and bioimaging expert, 
          with clinical practice in structural and inherited heart disease (Oxford University Hospital). Led research program 
          (Oxford University BHF Centre of Research Excellence and Osaka University) investigating real-time visualization of 
          intracellular signaling in the context of inherited cardiomyopathy, diabetes, and stem-cell derivatives that 
          might be used in cardiac regeneration, by high-content advanced light microscopy. Fellow of the Society of Cardiac 
          Angiography and Interventions (Congenital council structural heart sub-committee). Member of the Royal College of Physicians, 
          the Association of Inherited Cardiac Conditions, the British Cardiac Society (Program Committee), 
          and the Genomics England Clinical Interpretation Panel (Cardiovascular sub-domain).
        </p>
          </Modal.Description>
        </Modal.Content>
      </Modal>

      <Modal size='large' trigger={
        <Card color='blue'>
        <Image src={JoeT} size='tiny' wrapped ui={false} />
        <Card.Content>
        <Card.Header>Dr. Joseph Wing-On Tam</Card.Header>
        <Card.Description>
        Vice Chairman
        </Card.Description>
        </Card.Content>
        </Card>
      }>
      <Modal.Header>Dr. Joseph Wing-On Tam, Vice Chairman</Modal.Header>
      <Modal.Content scrolling >
      <Modal.Description>
      <Header>
      PhD Chemistry (UC Davis), Postdoctoral (Northwestern)
      </Header>
      <p className="Card__Text__Body">
      Research pioneer with over 30 years of teaching and research experience in the biotechnology and diagnostics sector.
      Honorary Professor of the School of Biomedical Science and Retired Professor of Biochemistry at Li Ka Shing Faculty of Medicine, The
      University of Hong Kong. Founder, Retired CEO and Chairman, DiagCor Bioscience and Pangenia, Hong Kong.  Founder and President of the Hong Kong
      Biochemistry Association.  Visiting Professor at UCSF, Baylor Medical College, and Medical College of Georgia; Scientist of National Institute of Health.
      </p>
      </Modal.Description>
      </Modal.Content>
      </Modal>

      <Modal size='large' trigger={
        <Card color='blue'>
        <Image src={Peter} wrapped ui={false} />
        <Card.Content>
        <Card.Header>Peter Cheung</Card.Header>
        <Card.Description>
        CEO and Chief Investment Officer
        </Card.Description>
        </Card.Content>
        </Card>
      }>
      <Modal.Header>Peter Cheung, CEO and Chief Investment Officer</Modal.Header>
      <Modal.Content scrolling >
      <Modal.Description>
      <Header>
      MSc Major Program Management (Oxford), MBA (USC), BSc Economics & Statistics (Hawaii).
      Chartered Financial Analyst with completion of investment management
      workshops at Princeton and Cambridge
      </Header>
      <p className="Card__Text__Body">
      Venture partner at Paladin Capital Group, a venture capital firm based in Washington, DC known for its expertise in cyber and bioscience investments.
      In 1983, founded Amervest Company, Inc. which served as external investment advisor to City of Los Angeles, L.A. Community Redevelopment Agency, Water Replenishment District,
      California Educational Facilities Financing Authority, L.A. County Mass Transit, Hong Kong Mass Transit Railway, and 20 other
      educational institutions.
      Formerly Treasurer and Chief Investment Officer at University of Southern California (USC), rose through the ranks from financial analyst.
      Worked as Executive Trainee at Citibank (Hong Kong) and promoted to Management Analyst at Citibank (Los Angeles).
      Active member of CFA Los Angeles chapter and alumni groups sponsored by USC and Oxford. Served as a trustee or regent on the investment committee
      at Loyola Marymount University in Los Angeles and the Religious of the Sacred Heart of Mary.
      </p>
      </Modal.Description>
      </Modal.Content>
      </Modal>

      <Modal size='large' trigger={
        <Card color='blue'>
        <Image src={Guy} wrapped ui={false} />
        <Card.Content>
        <Card.Header>Guy Marshall</Card.Header>
        <Card.Description>
        COO
        </Card.Description>
        </Card.Content>
        </Card>
      }>
      <Modal.Header>Guy Marshall, COO</Modal.Header>
      <Modal.Content scrolling >
      <Modal.Description>
      <Header>
      MSc Major Programme Management (Oxford), BSc Geography (UCL), PG Cert in Climate Change Management (University of London)
      </Header>
      <p className="Card__Text__Body">
        Senior sales person on the London equity sales desk of largest Russian bank Sberbank. Covered Central Asia for Kazakh investment bank Visor Capital
        and was head of the London office. At Citigroup, Director on the equity sales desk for Central and Eastern Europe, Middle
        East and Africa, covering major financial institutions in the UK, Germany, and Switzerland. At the beginning of career founded a tour company specialising in
        post-communist Central Europe, before joining Nomura and subsequently Schroders to launch the first IPOs in the region as the markets reopened.
      </p>
      </Modal.Description>
      </Modal.Content>
      </Modal>

      </Card.Group>
  }

  <Divider/>

    </div>;
  }
}

export default Team;
